import React from "react";
import {components} from "react-select";

const MenuList = props => {
    return (
        <components.MenuList {...props}>{props.children}</components.MenuList>
    );
};

export default MenuList;